import { render } from "./VariantPrice.vue?vue&type=template&id=38ce7b22&lang=pug"
import script from "./VariantPrice.vue?vue&type=script&lang=js"
export * from "./VariantPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__